import { html } from '../../mixins/katapult-element.js';
import { html as litHtml } from 'lit';
import { KatapultModelEditorElement } from './katapult-editor-template.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import '../style-modules/paper-menu-button-style.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { DEFAULT_SCHEMAS } from '../../modules/KLogicSchemas.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import '../katapult-switcher/katapult-switcher.js';
/**
 * `element-name`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class ActionSequenceEditor extends KatapultModelEditorElement {
  static get template() {
    return html`
      ${PortalStyle}
      <style include="paper-menu-button-style">
        :host {
          display: block;
        }
        .fixedCell {
          flex: 0 0 calc(16.6% - 29px);
        }
        paper-header-content {
          --paper-row-style: {
            height: auto;
          };
        }
        .descriptionRow {
          background-color: var(--paper-grey-100);
          --paper-input-container-underline: {
            display: none;
          };
        }
        katapult-switcher {
          --katapult-switcher-paper-cell: {
            padding: 8px 16px;
          };
        }
      </style>
      <katapult-dialog id="querySelectorChainDialog" title="Query Selector Chain for Step [[add(editingItem.order, 1)]]" draggable>
        <paper-table rounded outline grow overflow-hidden dividers>
          <paper-table-scroll
            data-path$="sequence.[[editingItem.$key]].query_selector_chain"
            on-sort-changed="orderedItemsArraySortChanged"
          >
            <paper-row grey short slot="before">
              <paper-cell icon>
                <material-icon icon="swap_vert"></material-icon>
              </paper-cell>
              <paper-cell style="flex-grow: 1"></paper-cell>
            </paper-row>
            <template is="dom-repeat" items="[[getOrderedItemsArray(editingItem.query_selector_chain.*, sequence.*)]]" mutable-data>
              <paper-row slot="sortable">
                <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
                <!-- Action -->
                <paper-cell>
                  <katapult-drop-down
                    underline
                    label="Action"
                    value="[[item.action]]"
                    items="[[selectorChainActions]]"
                    on-value-changed="updateProperty"
                    label-function="[[CamelCase]]"
                    data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]].action"
                  ></katapult-drop-down>
                </paper-cell>
                <template is="dom-if" if="[[!equal(item.action, 'parent_element')]]">
                  <paper-cell>
                    <paper-input
                      underline
                      label="Selector"
                      value="[[item.selector]]"
                      on-value-changed="updateProperty"
                      data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]].selector"
                    ></paper-input>
                  </paper-cell>
                </template>
                <template is="dom-if" if="[[equal(item.action, 'query_selector_all')]]">
                  <paper-cell>
                    <paper-input
                      underline
                      label="Filter Property"
                      value="[[item.filter_property]]"
                      on-value-changed="updateProperty"
                      data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]].filter_property"
                    ></paper-input>
                  </paper-cell>
                  <paper-cell>
                    <paper-input
                      underline
                      label="Filter Value"
                      value="[[item.filter_value]]"
                      on-value-changed="updateProperty"
                      data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]].filter_value"
                    ></paper-input>
                  </paper-cell>
                  <paper-cell style="max-width:65px;">
                    <paper-input
                      underline
                      label="Index"
                      value="[[item.index]]"
                      on-value-changed="updateProperty"
                      data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]].index"
                    ></paper-input>
                  </paper-cell>
                </template>
                <paper-cell icon-button>
                  <katapult-button
                    icon="delete"
                    iconOnly
                    on-click="updateProperty"
                    data-path$="sequence.[[editingItem.$key]].query_selector_chain.[[item.$key]]"
                    data-value="$null"
                    noOutline
                  ></katapult-button>
                </paper-cell>
              </paper-row>
            </template>
            <paper-row class="addButton" light-grey short slot="after">
              <paper-cell ripple data-path$="sequence.[[editingItem.$key]].query_selector_chain" on-click="addOrderedItem">
                <material-icon icon="playlist_add"></material-icon>
                <div>Add Action</div>
              </paper-cell>
            </paper-row>
          </paper-table-scroll>
        </paper-table>
        <katapult-button slot="buttons" color="var(--secondary-color)" dialog-dismiss>Done</katapult-button>
      </katapult-dialog>
      <paper-table rounded outline grow slot="body" overflow-hidden dividers>
        <paper-table-scroll data-path="sequence" on-sort-changed="orderedItemsArraySortChanged">
          <paper-row grey short slot="before">
            <paper-cell icon>
              <material-icon icon="swap_vert"></material-icon>
            </paper-cell>
            <paper-cell style="flex-grow: 1"></paper-cell>
          </paper-row>
          <template is="dom-repeat" items="[[getOrderedItemsArray(sequence.*)]]" mutable-data>
            <div slot="sortable">
              <template is="dom-if" if="[[item.show_description]]">
                <paper-row class="descriptionRow">
                  <paper-cell icon></paper-cell>
                  <paper-cell>
                    <paper-textarea
                      value="[[item.description]]"
                      label="Description"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).description"
                    ></paper-textarea>
                  </paper-cell>
                  <paper-cell icon-button></paper-cell>
                  <paper-cell icon-button></paper-cell>
                </paper-row>
              </template>
              <paper-header-content white divider no-click-row no-expand="[[!nestedAction(item.action)]]">
                <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>

                <!-- Action -->
                <paper-cell slot="header" class="fixedCell">
                  <katapult-drop-down
                    underline
                    label="Action"
                    value="[[item.action]]"
                    value-path="$key"
                    label-path="label"
                    items="[[actions]]"
                    on-value-changed="updateProperty"
                    data-path="sequence.$(model.item.$key).action"
                  ></katapult-drop-down>
                </paper-cell>

                <!-- Selector -->
                <template is="dom-if" if="[[getSub(actions, item.action, 'selector')]]">
                  <!-- Selector Type -->
                  <template is="dom-if" if="[[configuredOptions.domains_to_select_by_label]]" restamp>
                    <paper-cell slot="header" style="flex-basis:min-content; flex-grow:0;">
                      <katapult-switcher
                        items="[[selector_types]]"
                        value="[[item.selector_type]]"
                        data-path="sequence.$(model.item.$key).selector_type"
                        on-value-changed="updateProperty"
                      ></katapult-switcher>
                    </paper-cell>
                  </template>
                  <template is="dom-if" if="[[equal(item.selector_type, 'Chain')]]">
                    <paper-cell slot="header" class="fixedCell" center>
                      <katapult-button
                        icon="move_down"
                        color="[[getKLogicButtonColor(item.query_selector_chain)]]"
                        on-click="openQueryselectorChainEditor"
                      ></katapult-button>
                    </paper-cell>
                  </template>
                  <template is="dom-if" if="[[!equal(item.selector_type, 'Chain')]]">
                    <paper-cell slot="header" class="fixedCell">
                      <paper-input
                        underline
                        label="Selector"
                        value="[[item.selector]]"
                        on-value-changed="updateProperty"
                        data-path="sequence.$(model.item.$key).selector"
                      ></paper-input>
                    </paper-cell>
                  </template>
                  <paper-cell slot="header" style="max-width:70px;">
                    <paper-input
                      underline
                      label="Timeout"
                      placeholder="3"
                      value="[[item.timeout]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).timeout"
                    >
                      <span slot="suffix">s</span>
                    </paper-input>
                  </paper-cell>
                </template>

                <!-- Time -->
                <template is="dom-if" if="[[getSub(actions, item.action, 'time')]]">
                  <paper-cell slot="header" class="fixedCell">
                    <paper-input
                      underline
                      type="number"
                      min="0"
                      label="Time"
                      value="[[item.time]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).time"
                    >
                      <span slot="suffix">ms</span>
                    </paper-input>
                  </paper-cell>
                </template>

                <!-- Value Type -->
                <template is="dom-if" if="[[getSub(actions, item.action, 'value_type')]]">
                  <paper-cell slot="header" class="fixedCell">
                    <katapult-drop-down
                      underline
                      label="Value Type"
                      value="[[item.value_type]]"
                      items="[[value_types]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).value_type"
                    ></katapult-drop-down>
                  </paper-cell>
                </template>

                <!-- Text -->
                <template is="dom-if" if="[[getSub(actions, item.action, 'text')]]">
                  <paper-cell slot="header" class="fixedCell">
                    <paper-input
                      underline
                      label="[[getSub(actions, item.action, 'text')]]"
                      value="[[item.text]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).text"
                    ></paper-input>
                  </paper-cell>
                </template>

                <!-- Input Value -->
                <template is="dom-if" if="[[showDataInput(item.value_type, item.action)]]">
                  <paper-cell slot="header" class="fixedCell">
                    <katapult-drop-down
                      underline
                      label="Value"
                      value="[[item.data]]"
                      items="[[dataItems]]"
                      label-path="label"
                      value-path="key"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).data"
                    ></katapult-drop-down>
                  </paper-cell>
                </template>
                <template is="dom-if" if="[[equal(item.value_type, 'Text')]]">
                  <paper-cell slot="header" class="fixedCell">
                    <paper-input
                      underline
                      label="Text"
                      value="[[item.text]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).text"
                    >
                    </paper-input>
                  </paper-cell>
                </template>

                <template is="dom-if" if="[[equal(item.action, 'loop_block')]]">
                  <paper-cell slot="header" class="fixedCell">
                    <katapult-drop-down
                      underline
                      label="Label"
                      value="[[item.label]]"
                      items="[[getLoopItems(item.data, previewValues)]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).label"
                    ></katapult-drop-down>
                  </paper-cell>
                </template>

                <!-- Output Value -->
                <template is="dom-if" if="[[equal(item.action, 'output_value')]]">
                  <paper-cell
                    slot="header"
                    center
                    class="fixedCell"
                    style="gap: 10px; font-size: 12px; color: rgb(115, 115, 115); flex-direction:column;"
                  >
                    <span>Output Logic</span>
                    <katapult-button
                      icon="functions"
                      iconOnly
                      size="small"
                      color="{{getKLogicButtonColor(item.output_logic)}}"
                      on-click="openLogicEditor"
                      data-type="output_logic"
                    >
                      <katapult-tooltip>Custom Logic</katapult-tooltip>
                    </katapult-button>
                  </paper-cell>
                  <template is="dom-if" if="[[showLocationType(automationType, parentAction)]]">
                    <paper-cell slot="header" class="fixedCell">
                      <katapult-drop-down
                        underline
                        label="Location"
                        value="[[item.location_type]]"
                        items="[[getLocationTypes(automationType, parentAction)]]"
                        on-value-changed="updateProperty"
                        data-path="sequence.$(model.item.$key).location_type"
                      ></katapult-drop-down>
                    </paper-cell>
                  </template>
                  <template is="dom-if" if="[[!equal(item.location_type, 'Loop Item')]]">
                    <paper-cell slot="header" class="fixedCell">
                      <katapult-drop-down
                        underline
                        label="Attribute"
                        value="[[item.attribute]]"
                        items="[[getOutputAttributeList(otherAttributes, automationType, item.location_type)]]"
                        label-path="label"
                        value-path="value"
                        on-value-changed="updateProperty"
                        data-path="sequence.$(model.item.$key).attribute"
                      ></katapult-drop-down>
                    </paper-cell>
                  </template>
                </template>

                <template is="dom-if" if="[[showLoopItemInput(item.value_type, item.location_type)]]">
                  <paper-cell slot="header" class="fixedCell">
                    <katapult-drop-down
                      underline
                      label="Data"
                      value="[[item.data]]"
                      items="[[getLoopItems(parentDataItem, previewValues)]]"
                      on-value-changed="updateProperty"
                      data-path="sequence.$(model.item.$key).data"
                    ></katapult-drop-down>
                  </paper-cell>
                </template>

                <!-- Conditional Block -->
                <template is="dom-if" if="[[equal(item.action, 'conditional_block')]]">
                  <paper-cell
                    slot="header"
                    center
                    class="fixedCell"
                    style="gap: 10px; font-size: 12px; color: rgb(115, 115, 115); flex-direction:column;"
                  >
                    <span>Conditional Logic</span>
                    <katapult-button
                      icon="functions"
                      iconOnly
                      size="small"
                      color="{{getKLogicButtonColor(item.conditional_logic)}}"
                      on-click="openLogicEditor"
                      data-type="conditional_logic"
                    >
                      <katapult-tooltip>Custom Logic</katapult-tooltip>
                    </katapult-button>
                  </paper-cell>
                </template>

                <div slot="header" style="flex-grow:1;"></div>

                <paper-cell slot="header" icon-button>
                  <paper-menu-button class="manage-item-button" horizontal-align="right" vertical-align="top" vertical-offset="48">
                    <katapult-button iconOnly noBorder slot="dropdown-trigger" icon-button icon="more_vert"></katapult-button>
                    <div slot="dropdown-content" on-click="closeMenu">
                      <div
                        flex
                        align-center
                        style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                        on-click="addActionBelow"
                      >
                        <paper-ripple></paper-ripple>
                        <material-icon icon="add"></material-icon>
                        <div>Add Action Below</div>
                      </div>
                      <div
                        flex
                        align-center
                        style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                        data-type="duplicate"
                        on-click="addActionBelow"
                      >
                        <paper-ripple></paper-ripple>
                        <material-icon icon="content_copy"></material-icon>
                        <div>Duplicate Action</div>
                      </div>
                      <template is="dom-if" if="[[!item.show_description]]">
                        <div
                          flex
                          align-center
                          style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                          data-path="sequence.$(model.item.$key).show_description"
                          data-value="$true"
                          on-click="updateProperty"
                        >
                          <paper-ripple></paper-ripple>
                          <material-icon icon="notes"></material-icon>
                          <div>Add Description</div>
                        </div>
                      </template>
                      <template is="dom-if" if="[[item.show_description]]">
                        <div
                          flex
                          align-center
                          style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                          data-path="sequence.$(model.item.$key).show_description"
                          data-value="$false"
                          on-click="updateProperty"
                        >
                          <paper-ripple></paper-ripple>
                          <material-icon icon="notes"></material-icon>
                          <div>Remove Description</div>
                        </div>
                      </template>
                      <div
                        flex
                        align-center
                        style="padding: 12px; gap: 8px; position: relative; cursor: pointer;"
                        data-path="sequence.$(model.item.$key)"
                        data-value="$null"
                        on-click="updateProperty"
                      >
                        <paper-ripple></paper-ripple>
                        <material-icon icon="delete"></material-icon>
                        <div>Delete Action</div>
                      </div>
                    </div>
                  </paper-menu-button>
                </paper-cell>
                <div slot="content">
                  <action-sequence-editor
                    style="margin:10px 20px;"
                    sequence="[[item.sequence]]"
                    data-path="sequence.$(model.item.$key).sequence"
                    on-sequence-changed="updateProperty"
                    data-items="[[dataItems]]"
                    other-attributes="[[otherAttributes]]"
                    automation-type="[[automationType]]"
                    configured-options="[[configuredOptions]]"
                    preview-values="[[previewValues]]"
                    parent-action="[[item.action]]"
                    parent-data-item="[[item.data]]"
                  ></action-sequence-editor>
                </div>
              </paper-header-content>
            </div>
          </template>
          <paper-row class="addButton" light-grey short slot="after">
            <paper-cell ripple data-path="sequence" on-click="addOrderedItem">
              <material-icon icon="playlist_add"></material-icon>
              <div>Add Action</div>
            </paper-cell>
          </paper-row>
        </paper-table-scroll>
      </paper-table>
    `;
  }
  static get properties() {
    return {
      actions: {
        type: Object,
        value: () => ({
          input_value: { label: 'Input Value', selector: true, value_type: true },
          output_value: { label: 'Output Value', selector: true },
          trigger_event: { label: 'Trigger Event', selector: true, text: 'Event Name' },
          conditional_block: { label: 'Conditional Block', selector: true },
          loop_block: { label: 'Loop Block' },
          print: { label: 'Print', value_type: true },
          error: { label: 'Error', value_type: true },
          pause_for_user: { label: 'Pause for User' },
          wait: { label: 'Wait', time: true },
          wait_for_pageload: { label: 'Wait for Pageload' },
          navigate_to_url: { label: 'Navigate to Url', text: 'Url' },
          select_frame: { label: 'Select Frame', text: 'Url' }
          // run_module:{ label:'Run Module' },
        })
      },
      automationType: {
        type: String
      },
      otherAttributes: {
        type: Object
      },
      parentAction: {
        type: String
      },
      parentDataItem: {
        type: String
      },
      value_types: {
        type: Array,
        value: () => ['Data', 'Text'],
        computed: 'getValueTypes(parentAction)'
      },
      operators: {
        type: Array,
        value: () => ['Equals', 'Does Not Equal']
      },
      selector_types: {
        type: Array,
        value: () => ['Selector', 'Label', 'Chain']
      },
      selectorChainActions: {
        type: Array,
        value: () => ['query_selector', 'query_selector_all', 'parent_element']
      },
      previewValues: {
        type: Object
      },
      sequence: {
        type: Object,
        notify: true
      },
      dataItems: {
        type: Array
      }
    };
  }
  static get observers() {
    return [];
  }
  ready() {
    super.ready();
    this.CamelCase = CamelCase;
  }
  nestedAction(action) {
    return ['conditional_block', 'loop_block'].includes(action);
  }
  showDataInput(value_type, action) {
    return value_type == 'Data' || action == 'loop_block';
  }
  getValueTypes(parentAction) {
    const types = ['Data', 'Text'];
    if (parentAction == 'loop_block') types.push('Loop Item');
    return types;
  }
  getLoopItems(parentDataItem, previewValues) {
    return Object.keys(previewValues?.[parentDataItem]?.value?.[0] ?? {});
  }
  getOutputAttributeList(otherAttributes, automationType, location_type) {
    const types = [];
    if (automationType === 'Job') types.push('job');
    else if (automationType === 'Node') {
      if (location_type === 'Node') types.push('node');
      if (location_type === 'Job') types.push('job');
    }
    return Object.keys(otherAttributes ?? {})
      .map((key) => ({ value: key, label: CamelCase(key) }))
      .filter((x) => otherAttributes[x.value].attribute_types?.some((y) => types.includes(y)));
  }

  showLocationType(automationType, parentAction) {
    return automationType == 'Node' || parentAction == 'loop_block';
  }

  getLocationTypes(automationType, parentAction) {
    const types = ['Job'];
    if (automationType == 'Node') types.push('Node');
    if (parentAction == 'loop_block') types.push('Loop Item');
    return types;
  }

  showLoopItemInput(value_type, location_type) {
    return value_type == 'Loop Item' || location_type == 'Loop Item';
  }

  getKLogicButtonColor(data) {
    if (typeof data === 'object' && !Array.isArray(data) && data !== null) return 'var(--secondary-color)';
    return 'white';
  }

  addActionBelow(e) {
    // Move all the existing items down by 1
    this.getOrderedItemsArray(this.sequence).forEach((item) => {
      if (item.order > e.model.item.order) {
        this.set(`sequence.${item.$key}.order`, item.order + 1);
      }
    });
    // Get the new value
    const value = e.currentTarget.dataset.type == 'duplicate' ? structuredClone(e.model.item) : {};
    value.order = e.model.item.order + 1;
    value.$key = FirebaseWorker.ref().push().key;
    // Add the new item after this one
    this.set(`sequence.${value.$key}`, value);
  }

  closeMenu(e) {
    e.currentTarget.parentElement.close();
  }

  async openLogicEditor(e) {
    const config = {
      schema: {
        job: DEFAULT_SCHEMAS.JOB,
        user: DEFAULT_SCHEMAS.USER,
        connection_lookup: DEFAULT_SCHEMAS.CONNECTION_LOOKUP
      }
    };
    const type = e.currentTarget.dataset.type;
    if (type == 'output_logic') {
      config.path = `sequence.${e.model.item.$key}.output_logic`;
      config.label = 'Output Logic';
      config.schema.result = 'text';
    } else if (type == 'conditional_logic') {
      config.path = `sequence.${e.model.item.$key}.conditional_logic`;
      config.label = 'Conditional Logic';
      config.schema.element = 'object';
    }

    if (this.parentAction == 'loop_block') {
      config.schema.loop_item = {};
      const loopItems = this.getLoopItems(this.parentDataItem, this.previewValues);
      loopItems?.forEach((item) => {
        config.schema.loop_item[item] = 'text';
      });
    }

    if (this.automationType == 'Node') {
      config.schema.node = DEFAULT_SCHEMAS.NODE;
      config.schema.node_id = 'text';
    }

    const existingEditorData = JSON.parse(JSON.stringify(this.get(config.path) || {}));

    const dialog = KatapultDialog.open({
      dialog: {
        title: `Custom Logic for ${config.label}`,
        draggable: true
      },
      template: () => litHtml`
      <div>
        <k-logic-editor block="${existingEditorData}" expand-editor></k-logic-editor>
      </div>
      <div slot="buttons">
        <katapult-button dialog-dismiss>Cancel</katapult-button>
        <katapult-button id="confirm" color="var(--secondary-color)" dialog-confirm>Save</katapult-button>
      </div>
      `
    });
    // Get the k-logic-editor
    const editor = dialog.querySelector('k-logic-editor');
    // set existing data on the editor so that when we open the dialog the editor has the right data
    editor.block = existingEditorData;

    // set the schema for the k-logic editor
    editor.schema = config.schema;

    await dialog.openStart;
    // Get the confirm button.
    const confirmButton = dialog.querySelector('#confirm');
    // get data from the editor
    confirmButton.addEventListener('click', async () => {
      this.updateProperty(new CustomEvent('update-item', { detail: { path: config.path, value: editor.block } }));
      dialog.close();
    });
  }

  async openQueryselectorChainEditor(e) {
    this.editingItem = e.model.item;
    this.$.querySelectorChainDialog.open();
  }
}
window.customElements.define('action-sequence-editor', ActionSequenceEditor);
